import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Tooltip,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SettingsIcon from '@mui/icons-material/Settings';
import CustomFieldsManager from '../CustomFieldsManager';

export default function ModalManageCustomFields({ maintenanceId, maintenanceName }) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Tooltip title={t('customFields.manageFields')}>
        <IconButton onClick={handleOpen} size="small" color="primary">
          <SettingsIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
        <DialogTitle>
          {t('customFields.manageFields')}
          <IconButton
            onClick={handleClose}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <CustomFieldsManager
            maintenanceId={maintenanceId}
            maintenanceName={maintenanceName}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
